var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmdShow24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M12,17c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5s5,2.2,5,5C17,14.8,14.8,17,12,17z M12,8c-2.2,0-4,1.8-4,4 c0,2.2,1.8,4,4,4s4-1.8,4-4C16,9.8,14.2,8,12,8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M12,20c-4.9,0-9.3-2.8-11.8-7.5c-0.2-0.3-0.2-0.7,0-1C2.7,6.8,7.1,4,12,4s9.3,2.8,11.8,7.5 c0.2,0.3,0.2,0.7,0,1l0,0C21.3,17.2,16.9,20,12,20z M12,5C7.5,5,3.4,7.6,1.1,12c2.4,4.4,6.4,7,10.9,7s8.6-2.6,10.9-7c0,0,0,0,0,0 C20.6,7.6,16.5,5,12,5z M23.4,12.2L23.4,12.2L23.4,12.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdShow24);
export default __webpack_public_path__ + "static/media/cmdShow24.2ea705c9a32725be4495fc878a743091.svg";
export { ForwardRef as ReactComponent };